import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

function OptionsItemSelector(props) {
  const { items, handleChange, selectedItem } = props;

  const menuItems = items.map((item) => (
    <MenuItem
      key={item.value}
      value={item.value}
      typeOfMeal={item.typeOfMeal}
      valueNote={item.valueNote}
    >
      {item.label}
    </MenuItem>
  ));

  return (
    <MuiThemeProvider>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        defaultValue={selectedItem.id}
        value={items.value}
        onChange={(event, target) =>
          handleChange(
            event.target.value,
            target.props.typeOfMeal,
            target.props.valueNote
          )
        }
        required
      >
        {menuItems}
      </Select>
    </MuiThemeProvider>
  );
}

OptionsItemSelector.propTypes = {
  items: PropTypes.arrayOf.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape(PropTypes.shape()),
};

OptionsItemSelector.defaultProps = {
  selectedItem: {},
};

export default withTranslation('common')(OptionsItemSelector);
